import {Directive} from '@angular/core';
import {BaseComponent} from '../../abstract/base.component';
import {ErrorConstants} from '../../shared/constants/error-constants';
import {WebhookLogModel} from '../../data/model/WebhookLogModel/webhook_log.model';
import {ApiResponseModel} from '../../data/model/ApiResponseModel/api-response.model';

@Directive()
// tslint:disable-next-line:directive-class-suffix
export abstract class WebhookListAction extends BaseComponent {

  protected _webhookListUrl: string;

  getWebhookListData() {
    this.loadFlag = true;
    this.dataManager.getRequest(this._webhookListUrl, 0)
      .subscribe(
        (response) => {
          this.passWebhookList(response);
          if (response.data.length === 0) {
            this.errorMsg = ErrorConstants.webhookLogDetailErrorMsg[0];
          } else {
            this.errorMsg = null;
          }
        },
        error => {
          this.errorMsg = this.networkErrorHandler(error.error, ErrorConstants.webhookLogDetailErrorMsg);
          this.passError(error);
        }
      );
  }

  protected abstract passWebhookList(webhookResponse: ApiResponseModel<WebhookLogModel>);

  protected abstract passError(error: any);
}
